module.exports = __webpack_public_path__ + "img/user.ed070f7c.svg";